import React, { useContext, useState } from "react";
import Modal from "../../../Components/Modals/modal.module.css";
import DashboardStyle from "../../../Styles/Dashboard.module.css";
import Action from "../../../Images/actions.svg";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import {
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
  SlideCheckBox,
} from "../../../Components/Forms/InputTemplate";
import Select from "react-select";
import { useSearchParams } from "react-router-dom";
import { ModalContext } from "../../../../../utils/contexts/Modals/ModalContext";
import { useSelector } from "react-redux";
import { Regrex } from "../../../../../utils/functions/Regex";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import Style from "../../../Components/Modals/Style/modalStyle.module.css";
// import Timeline from "../../../Components/Modals/Processingstages/Timeline";
import TimelinePhases from "../../../Components/Modals/Processingstages/TimelinePhases.js";
import { useReasonOptions } from "../../../../../utils/hooks/useReasons.js";

export function ModalOps(props) {
  const { isOpen, closeModal, details, setDetails, type } =
    useContext(ModalContext);

  return (
    <>
      <AppModalTemplate
        padding={"1.75rem"}
        isOpen={isOpen}
        width={"340px"}
        closeFunction={() => closeModal()}
        zIndex={999}
      >
        <ApprovalModal
          closeModal={() => closeModal()}
          details={details}
          setDetails={setDetails}
          type={type}
        />
      </AppModalTemplate>
      {/* )} */}
    </>
  );
}

export function useApprovals() {
  const [isOpen, setIsOpen] = useState(false);

  const { openModal, closeModal } = useContext(ModalContext);

  return {
    Modal,
    isOpen,
    setIsOpen,
    openModal,
    closeModal,
  };
}

function ApprovalModal({ closeModal, details, type }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [comment, setComment] = useState("");
  const {
    global,
    assets,
    vendor,
    procurement,
    assetSetUp,
    consumable,
    consummableSetUp,
    fleet,
    fluelRequest,
    report,
  } = useSelector((state) => state);

  const { reasons, isLoading: isLoadingReasons } = useReasonOptions();
  console.log(reasons);

  const isLoading =
    isLoadingReasons ||
    assets?.isLoading ||
    assets?.isLoading ||
    vendor?.isLoading ||
    global?.isLoading ||
    procurement.isLoading ||
    assetSetUp?.isLoading ||
    consumable?.isLoading ||
    fleet?.isLoading ||
    consummableSetUp?.isLoading ||
    fluelRequest?.isLoading ||
    report?.isLoading;

  const formMethods = useForm({
    mode: "all",
  });

  const {
    handleSubmit,
    watch,
    setValue,
    formState: { isValid },
  } = formMethods;

  const view_date = () => {
    const today = new Date();
    if (watch("numOfDays")) {
      const date = FormatDateTime(
        new Date(today.setDate(today.getDate() + +watch("numOfDays")))
      );
      return `Suspend Till: ${date}`;
    }

    return "";
  };

  // eslint-disable-next-line no-unused-vars
  const [params, setParams] = useSearchParams({});

  const {
    submitData,
    decisions,
    button,
    title,
    isOther,
    isWorkflowApproval,
    isDelete,
    isDeleteSupport,
    isOtherSupport,
    sendIsOptional,
    commentIsOptional,
    isRating,
    isRatingSupport,
    isProcessingStages,
  } = details;

  const submit = (data) => {
    console.log({ data });
    setIsSubmitting(true);
    try {
      submitData({ ...data, comment });
    } catch (error) {
      throw error;
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isWorkflowApproval === true) {
    return (
      <>
        <div>
          <img className={Modal?.modal_action_img} src={Action} alt="action" />
          <h3 className={Modal?.modal_action_h3}>{title}</h3>
          <hr className={Modal?.modal_action_hr} />
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <Select
                name={"approvalReasonId"}
                id={"approvalReasonId"}
                className=""
                title={"Select a reason"}
                placeholder={"Select"}
                disabled={false}
                options={reasons?.map((r) => ({
                  label: r.label,
                  value: r.value,
                }))}
                onChange={(selectedOption) =>
                  setValue("approvalReasonId", selectedOption.value)
                }
                // isOptional={true}
              />

              <div className="mt-4">
                <FormTextArea
                  title={"Comment (optional)"}
                  camelCase={"comment"}
                  placeholder={"Please enter comment"}
                  type="textbox"
                  className={Modal.input_modal}
                  rowsLines={"4"}
                  isOptional={true}
                  moreRegister={{
                    value: comment,
                    onChange: (ev) => setComment(ev.target.value),
                  }}
                />
              </div>

              <div className={Modal.button_cage}>
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid || isSubmitting}
                  className={DashboardStyle?.button_cage_weight}
                  bg={button.color === "red" ? "#E61B00" : ""}
                >
                  {button.name}
                </ActionButtons>
                <SupportButtons
                  onClick={() => closeModal()}
                  className={Modal?.button_cage_weight_without_border}
                >
                  No, Close
                </SupportButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </>
    );
  }

  if (isProcessingStages === true) {
    return (
      <div className={Style.processing_stages}>
        <h3 className={Modal?.modal_action_h3}>Stage Preview</h3>
        <div>
          {/* <p>
            Status: <span>Processing</span>
          </p> */}
          {/* <p>
            Levels of Approval: <span>{decisions?.lenght}</span>
          </p> */}
        </div>

        <div>
          <TimelinePhases decisions={decisions} />
        </div>

        {/* <div>
          <div>
            <p>Request Approval: (Approved)</p>
            <p>
              Approver: <span>Azeez Akeem</span>
            </p>
          </div>

          <div>
            <p>Request Approval: (Approved)</p>
            <p>
              Approver: <span>Azeez Akeem</span>
            </p>
          </div>

          <div>
            <p>Request Approval: (Approved)</p>
            <p>
              Approver: <span>Azeez Akeem</span>
            </p>
          </div>
        </div> */}

        <SupportButtons
          onClick={() => closeModal()}
          className={Modal?.button_cage_weight}
        >
          Close
        </SupportButtons>
      </div>
    );
  }

  if (isOther === true) {
    return (
      <>
        <div>
          <img className={Modal?.modal_action_img} src={Action} alt="action" />
          <h3 className={Modal?.modal_action_h3}>{title}</h3>
          <p style={{ fontSize: "0.9rem", textAlign: "center" }}>
            {isOtherSupport}
          </p>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <div className={Modal.button_cage}>
                <SupportButtons
                  onClick={() => closeModal()}
                  className={Modal?.button_cage_weight_without_border}
                >
                  No, Close
                </SupportButtons>
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid || isSubmitting}
                  className={DashboardStyle?.button_cage_weight}
                  bg={button.color === "red" ? "#E61B00" : ""}
                >
                  {button.name}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </>
    );
  }

  if (isDelete === true) {
    return (
      <>
        <div>
          <img className={Modal?.modal_action_img} src={Action} alt="action" />
          <h3 className={Modal?.modal_action_h3}>{title}</h3>
          <p style={{ fontSize: "0.9rem", textAlign: "center" }}>
            {isDeleteSupport}
          </p>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <div className={Modal.button_cage}>
                <SupportButtons
                  onClick={() => closeModal()}
                  className={Modal?.button_cage_weight_without_border}
                >
                  No, Close
                </SupportButtons>
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid || isSubmitting}
                  className={DashboardStyle?.button_cage_weight}
                  bg={button.color === "red" ? "#E61B00" : ""}
                >
                  {button.name}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </>
    );
  }

  if (isRating === true) {
    return (
      <>
        <div>
          <img className={Modal?.modal_action_img} src={Action} alt="action" />
          <h3 className={Modal?.modal_action_h3}>{title}</h3>

          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              {isRatingSupport}
              <div className={Modal.button_cage}>
                <SupportButtons
                  onClick={() => closeModal()}
                  className={Modal?.button_cage_weight_without_border}
                >
                  No, Cancel
                </SupportButtons>
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  className={DashboardStyle?.button_cage_weight}
                  bg={button.color === "red" ? "#E61B00" : ""}
                >
                  {button.name}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <img className={Modal?.modal_action_img} src={Action} alt="action" />
        <h3 className={Modal?.modal_action_h3}>{title}</h3>
        <hr className={Modal?.modal_action_hr} />
        <FormProvider {...formMethods}>
          <FormTemplate handleSubmit={handleSubmit(submit)}>
            {type === "vendor_suspend" && (
              <>
                <div
                  style={{
                    display: "flex",
                    gap: "0.8rem",
                    justifyContent: "center",
                  }}
                >
                  <FormInput
                    style={{ width: "100%" }}
                    title={"Number of Days"}
                    camelCase={"numOfDays"}
                    placeholder={"Enter Number of Days"}
                    // isOptional={true}
                    registerOptions={{
                      pattern: {
                        value: Regrex.numbers,
                        message: "Enter a Duration",
                      },
                    }}
                  />
                </div>
                <small>{`${view_date()}`}</small>
                <hr
                  style={{ marginTop: "0.35rem" }}
                  className={Modal?.modal_action_hr}
                />
              </>
            )}
            <FormTextArea
              title={"Comment"}
              camelCase={"comments"}
              placeholder={"Please enter comment"}
              type="textbox"
              className={Modal.input_modal}
              rowsLines={"5"}
              isOptional={commentIsOptional}
            />

            {/* this is temporarily disabled */}
            {false && sendIsOptional !== true && (
              <SendMail name={"Send notification to vendor"} />
            )}

            <div className={Modal.button_cage}>
              <ActionButtons
                isLoading={isLoading}
                disabled={!isValid || isSubmitting}
                className={DashboardStyle?.button_cage_weight}
                bg={button.color === "red" ? "#E61B00" : ""}
              >
                {button.name}
              </ActionButtons>
              <SupportButtons
                onClick={() => closeModal()}
                className={Modal?.button_cage_weight_without_border}
              >
                No, Close
              </SupportButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </div>
    </>
  );
}

export function SendMail({ name }) {
  return (
    <SlideCheckBox
      style={{
        margin: "1rem 0 0.75rem 0",
      }}
      isOptional={false}
      camelCase={"send"}
      name={name}
    />
  );
}
